"use client";
import { useEffect, useState } from "react";

// Tailwind's lg breakpoint — below it the inventory UI is in "mobile" mode.
// Replaces the server-side user-agent sniff (getDeviceType) so inventory HTML
// is identical for every device and safe to shared-cache (P3). SSR and the
// first client render use the desktop variant; the value corrects on mount.
const MOBILE_QUERY = "(max-width: 1023px)";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const update = () => setIsMobile(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  return isMobile;
}
